
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.845 11.686l-.003-.012a2.684 2.684 0 012.632-3.208h2.754c.22 0 .404-.076.513-.167.094-.079.124-.153.126-.233V8A5.866 5.866 0 102.133 8a5.866 5.866 0 006.112 5.862c.03-.002.062-.011.108-.067a.554.554 0 00.11-.345c0-.078-.032-.203-.226-.642l-.003-.008-.02-.045-.015-.035c-.105-.24-.268-.613-.352-1.023l-.002-.011zm.45 3.508A7.199 7.199 0 01.8 8 7.2 7.2 0 018 .8 7.2 7.2 0 0115.2 8v.076c-.011 1.026-.945 1.724-1.972 1.724h-2.753a1.35 1.35 0 00-1.322 1.628c.056.271.17.532.284.795l.02.046c.171.388.34.774.34 1.181 0 .895-.608 1.708-1.502 1.744z","fill":"#282E3E"}}),_c('path',{attrs:{"d":"M5.35 8.943a.943.943 0 11-1.886 0 .943.943 0 011.885 0zM6.073 5.544a.943.943 0 11-1.885 0 .943.943 0 011.885 0zM9.63 4.201a.943.943 0 11-1.885 0 .943.943 0 011.885 0zM12.156 6.087a.943.943 0 11-1.885 0 .943.943 0 011.885 0z","fill":"#282E3E"}})])
          )
        }
      }
    